/*
 * Copyright (c) 2019. World Wide Generation Ltd
 */

import { Component, Input } from "@angular/core";
import { DndDropEvent } from "ngx-drag-drop";

@Component({
  selector: "wwg-dnd-list",
  templateUrl: "./dnd-list.component.html",
  styleUrls: ["./dnd-list.component.scss"]
})
export class DndListComponent {

  @Input() public values: any[] = [];
  @Input() private viewAttribute = 'name';
  @Input() public renderName: Function = this.getItemName;
  @Input() public renderTooltip: Function = this.getTootiltip;
  @Input() public displayDelete = false;
  @Input() public valueIdentifier = 'id';

  layout: any = {
    container: 'row',
    list: 'column',
    dndHorizontal: false
  };

  // DndDropEvent data will be based on this value
  getDraggable = (item: any) => {
    return this.valueIdentifier ? item[this.valueIdentifier] : item;
  }

  onDrop(event: DndDropEvent, list: any[], identifier: string) {
    if (list && (event.dropEffect === 'copy' || event.dropEffect === 'move')) {
      const toPosition = event.index !== undefined ? event.index : list.length;

      const from = list.findIndex((item) => {
        if (!identifier) {
          return item === event.data;
        }

        return item[identifier] === event.data;
      });
      list.splice(toPosition, 0, list.splice(from, 1)[0]);
    }
  }

  public removeItem(item: any, list: any[]): void {
    list.splice(list.indexOf(item), 1);
  }

  getItemName(item: any) {
    return item[this.viewAttribute];
  }

  getTootiltip(item: any) {
    return typeof item === 'string' ? item: '';
  }
}
